'use client';

import { usePathname } from 'next/navigation';
import { useState } from 'react';

import { transformHitForProductTile } from '@libs/algolia';
import {
    createItemsViewEvent,
    dataLayerPush,
    Events,
    mapCategoriesFromUrl,
    PageSectionAnalyticsTracking,
    trackEEImpression,
} from '@libs/analytics';
import type { Product } from '@libs/common-next';

import type { SectionTrackerProps } from './types';
import './ProductCarousel.scss';

export default function SectionTracker({ productHits, children }: SectionTrackerProps) {
    const [sentDataLayer, setSentDatalayer] = useState<boolean>(false);
    const router = usePathname();
    const productsData = productHits.map(product => transformHitForProductTile(product) as Product);
    return (
        <PageSectionAnalyticsTracking
            sectionId="product-card"
            eventCallback={() => {
                dataLayerPush({
                    event: Events.VIEW_ITEM_LIST,
                    ...createItemsViewEvent(
                        productsData,
                        'contentful',
                        'standard plp',
                        mapCategoriesFromUrl(router),
                        undefined
                    ),
                });

                trackEEImpression({
                    products: productsData.map(({ rawProductHit }, index) => ({
                        ...rawProductHit,
                        __position: index + 1,
                    })),
                    list: 'Product carousel', // yep, carousel is not capitalized.
                });
            }}
            enabled={!sentDataLayer}
            OnIntersect={() => setSentDatalayer(true)}
        >
            {children}
        </PageSectionAnalyticsTracking>
    );
}
